import type { FaireProductEntity } from "../../entity_types/product";

export const p_3jvkepc6zx: FaireProductEntity = {
  token: "p_3jvkepc6zx",
  type: "product",
  name: "HOUSE MATCHES / VASHON",
  brandToken: "b_eu4wj6o4ca",
  brandName: "STATE The Label",
  imageUrl:
    "https://cdn.faire.com/fastly/16699e29a9d9bb1d721b46fee9e05aaff5639f36f2977afd2ec63e7252bee7dd.gif",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9aedb58d14ccefbacc494357d2f550229c921781a34ee87cdf030b7de95c13c6.jpeg",
    "https://cdn.faire.com/fastly/8c661d962f4da58dc5859ffd04a85b3f9377d2dfa84c5f9faa904dcbe83f39e6.jpeg",
    "https://cdn.faire.com/fastly/f820bc0a029de93611f9f36b8976e774513027665f3f3865267e81017b663b74.jpeg",
    "https://cdn.faire.com/fastly/ec8d4697b5c8231a35bf97ecc7b201e44fe8ff5135bf55b19f8be8bce06616c6.jpeg",
    "https://cdn.faire.com/fastly/c6e4b304ff2781cb19829ac0839be6bbd8d596562378f4c927ca4718ced03521.jpeg",
    "https://cdn.faire.com/fastly/966a75d98d35a78c73175e5dc86dc548ad735350973dba39d7fab52b3a480cf6.jpeg",
    "https://cdn.faire.com/fastly/3415ebf198d8bd504ee1d8cf043f4c57ca3de477cf126169cb35e3f20296ad94.jpeg",
  ],
  priceDollars: 8,
  description:
    "\nThere's a new house on the block. \n\nWe always knew we wanted to expand the neighborhood, and our newest addition is just as cute as the original, and totally compliments it. The hand painted design - full of clever color combos and pleasing patterns - has been beautifully printed to show the brush strokes and character of the original. And no matter what side you can see, they all make you happy. \n\nThe original house matches started as a 3D model made from a cut up cereal box, and each side was hand painted at Adrienne's kitchen table. \n\nThe sliding drawer holds 100 4\" matches (with colorful match heads, of course!), and a large striker on the bottom gives you ample firing power. Pro tip: when the matches run out, just replace them with other 4\" matches!\n\n\nWhether they're on your mantle, the back of your toilet, residing on your bedside, or given as the *perfect* gift – our House Matches are at home wherever you place them.\n",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T02:36:27.292Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
